import { Message } from 'element-ui'
let messageInstance = null
const resetMessage = (options,close) => {
  if(messageInstance) {
      messageInstance.close()
  }
  // 不存在实例则赋予实例
  messageInstance = Message(options)
  if(close){
    messageInstance.close()
  }
};['error','success','info','warning'].forEach(type => {
  resetMessage[type] = options => {
      if(typeof options === 'string') {
          options = {
              message:options
          }
      }
      options.type = type
      return resetMessage(options)
  }
})
export const $Message = resetMessage